import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * Cart Quantity Selector
 *
 * Normal products:
 *   Shopify quantity = customer quantity
 *
 * Fabric products:
 *   Customer sees:
 *     3
 *     3.5
 *     4
 *     4.5
 *     5
 *
 *   Shopify stores:
 *     6
 *     7
 *     8
 *     9
 *     10
 *
 * Cart semantics:
 * "What should the total quantity BE in the cart"
 *
 * Unlike the product page, the cart selector uses
 * the absolute maximum quantity.
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {

  /**
   * Gets the effective maximum value for cart quantity selector.
   *
   * Cart uses the absolute maximum.
   *
   * For Fabric:
   *   max is the visible meter maximum.
   *
   * Example:
   *   Stock = 15 Shopify units
   *   Visible max = 7.5 meters
   *
   * Therefore:
   *   max = 7.5
   */
  getEffectiveMax() {
    const {
      max
    } = this.getCurrentValues();

    return max;
  }

  /**
   * Updates button states.
   *
   * Cart buttons are controlled client-side.
   *
   * Fabric:
   *   3 → 3.5 → 4 → 4.5
   *
   * Normal:
   *   1 → 2 → 3 → 4
   */
  updateButtonStates() {
    const {
      minusButton,
      plusButton
    } = this.refs;

    const {
      min,
      value
    } = this.getCurrentValues();

    const effectiveMax =
      this.getEffectiveMax();

    /*
     * MINUS
     *
     * Fabric minimum = 3 meters.
     */
    minusButton.disabled =
      value <=
      min + 0.0001;

    /*
     * PLUS
     *
     * Fabric:
     *   7.5 is maximum visible quantity.
     *
     * Normal:
     *   Uses normal absolute maximum.
     */
    plusButton.disabled =
      effectiveMax !== null &&
      value >=
        effectiveMax -
          0.0001;

    /*
     * Keep the hidden Shopify
     * quantity synchronized.
     *
     * Example:
     *
     * Visible:
     *   3.5
     *
     * Shopify:
     *   7
     */
    if (
      typeof this.syncFabricShopifyQuantity ===
      'function'
    ) {
      this.syncFabricShopifyQuantity();
    }
  }
}

if (
  !customElements.get(
    'cart-quantity-selector-component'
  )
) {
  customElements.define(
    'cart-quantity-selector-component',
    CartQuantitySelectorComponent
  );
}